import { triggerSimpleAjax } from "../../../helpers/httpHelper";
import { OTP_VERIFY_API } from "../../../helpers/constants/ekycApiUrl";

const OtpVerifyAction = (req) => {
    return new Promise((res, rej) => {
        triggerSimpleAjax(
            OTP_VERIFY_API,
            'POST',
            req,
            (response) => {
                res(response)
            },
            (err) => {
                rej(err)
            }
        )
    });
}

export default OtpVerifyAction;